import { LoggerLevelEnum } from '../enums/logger-level.enum';
import { NGXLogger } from 'ngx-logger';
import { Injectable } from '@angular/core';

/**
 * App logger service
 *
 * @export
 * @class Logger
 */
@Injectable()
export class Logger {

  constructor(private _logger: NGXLogger) {
  }

  trace(message?: any | (() => any), ...additional: any[]): void {
    this._logger.trace(message, ...additional);
  }

  debug(message?: any | (() => any), ...additional: any[]): void {
    this._logger.debug(message, ...additional);
  }

  info(message?: any | (() => any), ...additional: any[]): void {
    this._logger.info(message, ...additional);
  }

  warn(message?: any | (() => any), ...additional: any[]): void {
    this._logger.warn(message, ...additional);
  }

  error(message?: any | (() => any), ...additional: any[]): void {
    this._logger.error(message, ...additional);
  }

  fatal(message?: any | (() => any), ...additional: any[]): void {
    this._logger.fatal(message, ...additional);
  }

  log(level: LoggerLevelEnum, message?: any | (() => any), ...additional: any[]): void {
    (this._logger as any)._log(level, message, additional)
  }
}
